
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1906|8562)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
